import { i18n } from 'i18n';

export interface EditClientPageParams extends Record<string, string | undefined> {
  entityId: string
}
export const ROUTE_PARAM_IDENTIFIER = ':entityId';
export const ROUTE_PATH = `/admin/clients/${ROUTE_PARAM_IDENTIFIER}`;
export const TITLE = i18n._('Edit Client');
